import { render, staticRenderFns } from "./editIntoStockV4.vue?vue&type=template&id=2ca6e188&scoped=true&"
import script from "./editIntoStockV4.vue?vue&type=script&lang=js&"
export * from "./editIntoStockV4.vue?vue&type=script&lang=js&"
import style0 from "./editIntoStockV4.vue?vue&type=style&index=0&id=2ca6e188&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6e188",
  null
  
)

export default component.exports